module.exports = __webpack_public_path__ + "img/qrcode.e95b141b.png";